module.exports = __webpack_public_path__ + "images/d7c639084f684d66a1bc66855d193ed8-fontawesome-webfont.svg";